/**
/* © 2023 University of Cambridge
/* SPDX-FileCopyrightText: 2023 University of Cambridge
/* SPDX-License-Identifier: GPL-3.0-or-later
**/

// undo, redo, reset buttons
import * as pedcache from './pedcache.js';
import { btn_zoom, scale_to_fit } from './zoom.js';
import { copy_dataset, getProbandIndex, is_fullscreen, messages, prefixInObj } from './utils.js';

export function addButtons(options) {
	let opts = $.extend({
        // defaults
		btn_target: 'pedigree_history'
    }, options );

	//let btns = [{"fa": "fa-file-image", "title": "download PNG image"},
	//			{"fa": "fa-undo", "title": "undo"},
	//			{"fa": "fa-redo", "title": "redo"},
	//			{"fa": "fa-refresh", "title": "reset"}];

	let btns = [];
	btns.push({ "fa": "fa-globe", "title": "toggle-legend" });
	btns.push({ "fa": "fa-eye-slash", "title": "toggle-names" });

	btns.push({"fa": "fa-crosshairs", "title": "scale-to-fit"});
	if(opts.zoomSrc && (opts.zoomSrc.indexOf('button') > -1)) {
		if(opts.zoomOut !== 1)
			btns.push({"fa": "fa-minus-circle", "title": "zoom-out"});
		if(opts.zoomIn !== 1)
			btns.push({"fa": "fa-plus-circle", "title": "zoom-in"});
	}
	//btns.push({"fa": "fa-arrows-alt", "title": "fullscreen"});

	let lis = "";
	for(let i=0; i<btns.length; i++) {
		lis += '<span>';
		lis += '<i class="fa fa-lg ' + btns[i].fa + ' pe-2" aria-hidden="true" title="'+ btns[i].title + '"' +
		(btns[i].fa === "fa-arrows-alt" ? 'id="fullscreen" ' : '') +
		'></i>';

		lis += '</span>';
	}
	$( "#"+opts.btn_target ).html(lis);
	addPbuttonEvents(opts);
}

function addPbuttonEvents(opts) {
	// fullscreen
    $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function(_e)  {
		let local_dataset = pedcache.current(opts);
		if (local_dataset !== undefined && local_dataset !== null) {
			opts.dataset = local_dataset;
		}
		$(document).trigger('rebuild', [opts]);
		setTimeout(function(){ scale_to_fit(opts); }, 500);
    });

	$('#fullscreen').on('click', function(_e) {
		// toggle fullscreen
		if (!is_fullscreen()) {
			let target = $("#"+opts.targetDiv)[0];
			if (target.requestFullscreen) {
                target.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
				target.mozRequestFullScreen(); // Firefox
            } else if (document.documentElement.webkitRequestFullscreen) {
                target.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT); // Chrome and Safari
            } else if (document.documentElement.msRequestFullscreen) {
                target.msRequestFullscreen(); // IE
            }
		} else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
		}
	});

	// press and hold to zoom in/out
	let timeoutId = 0;
	function zoomIn() {btn_zoom(opts, 1.05);}
	function zoomOut() {btn_zoom(opts, 0.95);}
	$('.fa-plus-circle, .fa-minus-circle').on('mousedown', function() {
	    timeoutId = setInterval(($( this ).hasClass( "fa-plus-circle" ) ? zoomIn : zoomOut), 50);
	}).on('mouseup mouseleave', function() {
	    clearInterval(timeoutId);
	});

	// undo/redo/reset
	$( "#"+opts.btn_target ).on( "click", function(e) {
		e.stopPropagation();
		if($(e.target).hasClass("fg-grey"))
			return false;

		if($(e.target).hasClass('fa-undo')) {
			opts.dataset = pedcache.previous(opts);
			$("#"+opts.targetDiv).empty();
			$(document).trigger('build', [opts]);
		} else if ($(e.target).hasClass('fa-redo')) {
			opts.dataset = pedcache.next(opts);
			$("#"+opts.targetDiv).empty();
			$(document).trigger('build', [opts]);
		} else if ($(e.target).hasClass('fa-refresh')) {
			messages("Pedigree Reset",
			         "This may result in loss of some data. Reset now?",
			         reset, opts);
		} else if ($(e.target).hasClass('fa-crosshairs')) {
			scale_to_fit(opts);
		} else if ($(e.target).hasClass('fa-file-image')) {
			return;
		} else if ($(e.target).hasClass('fa-eye-slash')) {
			//var names = $("text[class='ped_label']");
			var names = $(".indi_name");
			if (names.length > 0) {
				let fontSize = names[0].style.fontSize === "0em" ? "0.75em" : "0em";
				for (let i = 0; i < names.length; i++) {
					names[i].style.fontSize = fontSize;
				}
			}
		} else if ($(e.target).hasClass('fa-globe')) {
			//LEGEND
			var isLegendEmpty = d3.select("#legend").html().length === 0;
			if (isLegendEmpty) {
				//show legend
				let svg = d3.select("#legend").append("svg:svg").attr("width", opts.width).attr("height", 100);
				svg.append("rect").attr("width", "100%").attr("height", 75).attr("rx", 6).attr("ry", 6).style("stroke", "darkgrey").style("fill", opts.background) // or none
					.style("stroke-width", 1);
				let numberOfNodesOnLegend = 6;
				let equalSpacing = opts.width / (numberOfNodesOnLegend + 1);
				let nodeData = [
					{ x: equalSpacing * 1, y: 32, y_offset: 32, data: { first_name: "EGM", extra_gastrointestinal_diagnosis_age: 1, name: "a" } },
					{ x: equalSpacing * 2, y: 32, y_offset: 32, data: { first_name: "Polyps", polyposis_diagnosis_age: 1, name: "b" } },
					{ x: equalSpacing * 3, y: 32, y_offset: 32, data: { first_name: "Other Cancer", non_colon_cancer_diagnosis_age: 1, name: "c" } },
					{ x: equalSpacing * 4, y: 32, y_offset: 32, data: { first_name: "Colon Cancer", colon_cancer_diagnosis_age: 1, name: "d" } },
					{ x: equalSpacing * 5, y: 32, y_offset: 32, data: { first_name: "Positive Genetic Test", positive_genetic_test: true, name: "e" } },
					{ x: equalSpacing * 6, y: 32, y_offset: 32, data: { first_name: "Negative Genetic Test", positive_genetic_test: false, name: "f" } },
				];
				let ped = svg.append("g").attr("class", "diagram");
				let node = ped.selectAll(".node").data(nodeData).enter().append("g").attr("transform", function (d, _i) {
					return "translate(" + d.x + "," + d.y + ")";
				});
				//provide a border to the node
				node.append("path").attr("shape-rendering", "geometricPrecision").attr("d", d3.symbol().size(function (_d) {
					return (opts.symbol_size * opts.symbol_size) + 2;
				}).type(function () {
					return d3.symbolCircle;
				})).style("stroke", function () {
					return "#303030";
				}).style("stroke-width", function () {
					return "0.15em";
				}).style("stroke-dasharray", function (d) {
					return !d.data.exclude ? null : "3, 3";
				}).style("fill", "white");

				// set a clippath
				// this is the white space in the nodes
				node.append("clipPath").attr("id", function (d) {
					return d.data.name;
				}).append("path").attr("class", "node").attr("d", d3.symbol().size(function () {
					return opts.symbol_size * opts.symbol_size;
				}).type(function () {
					return d3.symbolCircle;
				}));

				//diseases
				let pienode = node.selectAll("pienode").data(function (d) {
					// set the disease data for the pie plot
					let ncancers = 0;
					let cancers = $.map(opts.diseases, function (_val, i) {
						if (prefixInObj(opts.diseases[i].type, d.data)) {
							ncancers++;
							return 1;
						} else return 0;
					});
					if (ncancers === 0) cancers = [1];
					return [$.map(cancers, function (val, _i) {
						return {
							'cancer': val,
							'ncancers': ncancers,
							'id': d.data.name,
							'sex': d.data.sex,
							'proband': d.data.proband,
							'hidden': d.data.hidden,
							'affected': d.data.affected,
							'exclude': d.data.exclude
						};
					})];
				}).enter().append("g");
				pienode.selectAll("path").data(d3.pie().value(function (d) {
					return d.cancer;
				})).enter().append("path").attr("clip-path", function (d, i) {
					//akd 20231005 this makes white spaces in each node for diseases that person does not have
					//the 0.01 is to remove very small dashes at 0, 90, 180, and 360°
					if (d.data.ncancers !== 0) {
						if (i === 0) {
							d.startAngle = -0.01;
							d.endAngle = (Math.PI / 2) + 0.01;
						}
						else if (i === 1) {
							d.startAngle = (Math.PI / 2) - 0.01;
							d.endAngle = Math.PI + 0.01;
						}
						else if (i === 2) {
							d.startAngle = Math.PI - 0.01;
							d.endAngle = (3 * (Math.PI / 2)) + 0.01;
						}
						else if (i === 3) {
							d.startAngle = (3 * (Math.PI / 2)) - 0.01;
							d.endAngle = (2 * Math.PI) + 0.01;
						}
					}
					return "url(#" + d.data.id + ")";
				}) // clip the rectangle
					.attr("class", "pienode").attr("d", d3.arc().innerRadius(0).outerRadius(opts.symbol_size)).style("fill", function (d) {
						if (d.data.exclude) return 'lightgrey';
						if (d.data.ncancers === 0) {
							if (d.data.affected) return 'darkgrey';
							return opts.node_background;
						}
						if (d.data.cancer === 0) return 'white';
						return 'black';
						//return opts.diseases[i].colour;
					});

				//positive/negative genetic test
				node.filter(function (d) {
					return d.data.positive_genetic_test != null;
				}).append("path").attr("shape-rendering", "geometricPrecision").attr("transform", "translate(" + (opts.symbol_size / 8) + "," + (-opts.symbol_size / 8) + ")").attr("d", d3.symbol().size(function () {
					return (opts.symbol_size * opts.symbol_size) / 20;
				}).type(function () {
					return d3.symbolSquare;
				})).style("stroke", function () {
					return "#303030"; //"grey" "#303030"
				}).style("stroke-width", ".05em").style("stroke-dasharray", function (d) {
					return !d.data.exclude ? null : "3, 3";
				}).style("fill", function (d) {
					return d.data.positive_genetic_test ? "OrangeRed" : "RoyalBlue";
				});

				// TODO This is just copied from the addLabel function and renamed. It is a lazy quick fix after converting to a buildable pedigree.
				//add label for first name only
				addLabelCustom(opts,
					node,
					function (d) {
						return -(opts.symbol_size * d.data.first_name.length / 12);
					},
					function (d) {
						return yposCustom(d, [d.data.first_name], opts.font_size);
					},
					function (d) {
						if (opts.DEBUG) return ('first_name' in d.data ? d.data.first_name : d.data.name) + '  ' + d.data.id;
						return 'first_name' in d.data ? d.data.first_name : '';
					},
					'indi_details indi_name',
					['first_name']);
			}
			else {
				//remove legend
				d3.select("#legend").html("");
			}
		}

		// trigger fhChange event
		$(document).trigger('fhChange', [opts]);
	});
}

// Below methods with Custom suffix are used as a quick fix and could be refactored later.
// These support the custom addLabelCustom function above
function addLabelCustom(opts, node, fx, fy, ftext, class_label, labels) {
	node.filter(function (d) {
		return !d.data.hidden && (!labels || node_has_labelCustom(d, labels));
	}).append("text")
		.attr("class", (class_label ? class_label + ' ped_label' : 'ped_label'))
		.attr("x", fx)
		.attr("y", fy)
		.attr("font-family", opts.font_family)
		.attr("font-size", opts.font_size)
		.attr("font-weight", opts.font_weight)
		.text(ftext);
}
function node_has_labelCustom(d, labels) {
	for (let l = 0; l < labels.length; l++) {
		if (prefixInObj(labels[l], d.data) || labelIsPropertyValueCustom(labels[l], d.data))
			return true;
	}
	return false;
}
function labelIsPropertyValueCustom(value, obj) {
	let found = false;
	if (obj) $.each(obj, function (k, _n) {
		if (_n === value) {
			found = true;
			return found;
		}
	});
	return found;
}
function yposCustom(d, arr, font_size) {
	if (!node_has_labelCustom(d, arr)) return;
	d.y_offset = (!d.y_offset ? font_size * 2.35 : d.y_offset);
	return d.y_offset;
}

// reset pedigree and clear the history
function reset(opts) {
	let proband;
	if(opts.keep_proband_on_reset) {
		let local_dataset = pedcache.current(opts);
		let newdataset =  copy_dataset(local_dataset);
		proband = newdataset[getProbandIndex(newdataset)];
		//let children = pedigree_util.getChildren(newdataset, proband);
		proband.name = "ch1";
		proband.mother = "f21";
		proband.father = "m21";
		// clear pedigree data but keep proband data and risk factors
		pedcache.clear_pedigree_data(opts)
	} else {
		proband = {
			"name":"ch1","sex":"F","mother":"f21","father":"m21","proband":true,"status":"0","display_name":"me"
		};
		pedcache.clear(opts); // clear all storage data
	}
	delete opts.dataset;

	let selected = $("input[name='default_fam']:checked");
	if(selected.length > 0 && selected.val().indexOf("extended") > -1) {
		let partner = {"name":"Spj","mother":"f21","father":"m21","noparents":true,"status":"0","display_name":"partner"};
		let daughter = {"name":"zhk","sex":"F","mother":"ch1","father":"Spj","status":"0","display_name":"daughter"};
		let son     = {"name":"Knx","sex":"M","mother":"ch1","father":"Spj","status":"0","display_name":"son"};
		partner.sex    = (proband.sex === "F" ?"M":"F");
		daughter.mother = (proband.sex === "F" ? proband.name: partner.name);
		daughter.father = (proband.sex === "F" ? partner.name: proband.name);
		son.mother      = (proband.sex === "F" ? proband.name: partner.name);
		son.father      = (proband.sex === "F" ? partner.name: proband.name);
		opts.dataset    = [proband, partner, daughter, son];
	}

	if(selected.length > 0 && selected.val() === 'extended2') {    // secondary relatives
		opts.dataset.push(
			{"name":"wZA","sex":"M","top_level":true,"status":"0","display_name":"paternal grandfather"},
			{"name":"MAk","sex":"F","top_level":true,"status":"0","display_name":"paternal grandmother"},
			{"name":"zwB","sex":"M","top_level":true,"status":"0","display_name":"maternal grandfather"},
			{"name":"dOH","sex":"F","top_level":true,"status":"0","display_name":"maternal grandmother"},
			{"name":"MKg","sex":"F","mother":"MAk","father":"wZA","status":"0","display_name":"paternal aunt"},
			{"name":"xsm","sex":"M","mother":"MAk","father":"wZA","status":"0","display_name":"paternal uncle"},
			{"name":"m21","sex":"M","mother":"MAk","father":"wZA","status":"0","display_name":"father"},
			{"name":"f21","sex":"F","mother":"dOH","father":"zwB","status":"0","display_name":"mother"},
			{"name":"aOH","sex":"F","mother":"f21","father":"m21","status":"0","display_name":"sister"},
			{"name":"Vha","sex":"M","mother":"f21","father":"m21","status":"0","display_name":"brother"},
			{"name":"uuc","display_name":"maternal aunt","sex":"F","mother":"dOH","father":"zwB","status":"0"},
			{"name":"xIw","display_name":"maternal uncle","sex":"M","mother":"dOH","father":"zwB","status":"0"});
	} else if(selected.length > 0 && selected.val() === 'extended1') {    // primary relatives
		opts.dataset.push(
			{"name":"m21","sex":"M","mother":null,"father":null,"status":"0","display_name":"father","noparents":true},
			{"name":"f21","sex":"F","mother":null,"father":null,"status":"0","display_name":"mother","noparents":true},
			{"name":"aOH","sex":"F","mother":"f21","father":"m21","status":"0","display_name":"sister"},
			{"name":"Vha","sex":"M","mother":"f21","father":"m21","status":"0","display_name":"brother"});
	} else {
		opts.dataset = [
			{"name": "m21", "display_name": "father", "sex": "M", "top_level": true},
			{"name": "f21", "display_name": "mother", "sex": "F", "top_level": true},
			proband];
	}
	$(document).trigger('rebuild', [opts]);
}

export function updateButtons(opts) {
	let current = pedcache.get_count(opts);
	let nstore = pedcache.nstore(opts);
	let id = "#"+opts.btn_target;
	if(nstore <= current)
		$(id+" .fa-redo").addClass('fg-grey');
	else
		$(id+" .fa-redo").removeClass('fg-grey');

	if(current > 1)
		$(id+" .fa-undo").removeClass('fg-grey');
	else
		$(id+" .fa-undo").addClass('fg-grey');
}
